import { CustomerSummary } from "../CustomerSummary";
import { OpportunitySummary } from "../OpportunitySummary";
import { ProspectSummary } from "../ProspectSummary";
import { Button, DataSource, Label, Layout, LayoutHeader, Panel, Splitter, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerRelationshipManager extends Layout {
    buttonAddAction: Button;
    buttonAddQuote: Button;
    buttonQuoteHistory: Button;
    buttonRefresh: Button;
    buttonReschedule: Button;
    buttonSearchOrders: Button;
    buttonViewComments: Button;
    labelCallList: Label;
    layoutCustomerSummary: CustomerSummary;
    layoutOpportunitySummary: OpportunitySummary;
    layoutProspectSummary: ProspectSummary;
    layoutheaderCRM: LayoutHeader;
    panelBottom: Panel;
    panelButtons: Panel;
    panelLeft: Panel;
    panelSecondaryFilters: Panel;
    panelTop: Panel;
    sourceCallListProfile: DataSource;
    sourceCustomer: DataSource;
    sourceOpportunity: DataSource;
    sourceProspect: DataSource;
    sourceProspectiveSales: DataSource;
    splitterCallList: Splitter;
    splitterSalesData: Splitter;
    tabCustomer: Tab;
    tabOpportunity: Tab;
    tabProspect: Tab;
    tableActivities: Table;
    tableCustomers: Table;
    tableOpportunities: Table;
    tableProspects: Table;
    tabsetCRM: Tabset;
    textboxLastRefresh: Textbox;
}
